import { Component, OnInit, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { Identity } from '../models/customer.model';
import { SetIdentityAction } from '../statemanagement/action/identity.action';
import { BaseComponents } from '../../../base.component';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
import { ReferenceService } from 'src/app/services/reference.service';

import liff from '@line/liff';
@Component({
    selector: 'app-form-update-line',
    templateUrl: './form-update-line.component.html',
    styleUrls: ['./form-update-line.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormUpdateLineComponent extends BaseComponents implements OnInit {

  state: string = 'register';
  log_session_text: string = "form-update-line";
  referenceUUID: string | null = null;
  constructor(
    protected injectorObj: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private lineStateAction: LineStateActionService,
    private lineActionService: LineStateActionService,
    private referenceService:ReferenceService,
    private getMaskingService : GetMaskingService,
  ) { 
    super(injectorObj)
  }

  navigate = "";
  queryParams = {}
  ngOnInit() {
    const funcName = 'ngOnInit';
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.log_session_text = `form-update-line referenceUUID:[${this.referenceUUID}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    this.route.queryParams.take(1).subscribe(async (params) => {
      this.navigate = decodeURIComponent(params['navigate'])
      if (params['queryParams']) {
        this.logger.info(`${this.log_session_text} ${funcName} queryParams:${params['queryParams']}`);
        this.queryParams = JSON.parse(decodeURIComponent(params['queryParams']));
      }
    })
  }

  onClickConfirme() {
    const funcName = 'onClickConfirme';
    console.log('confirme line');
    const identity = this.lineStateAction.identityStateInfo;
    console.log(identity)
    const identity_data = {
      "id_card": identity ? identity["id_card"] : "",
      "phone_number": identity ? identity["phone_number"] : "",
      "update_chanel_identity_flag": true
    } as Identity;
    const log_identity_data = {
      "id_card": this.getMaskingService.maskingData(identity_data.id_card),
      "phone_number": this.getMaskingService.maskingData(identity_data.phone_number),
      "update_chanel_identity_flag": identity_data.update_chanel_identity_flag
    }
    this.logger.info(`${this.log_session_text} ${funcName} identity_data:${JSON.stringify(log_identity_data)}`);
    this.lineActionService.sinkIdentity.next(new SetIdentityAction(identity_data))
    return this.redirectToNextPage()
  }

  redirectToChateRoom() {
    console.log('chate room')
    this.logger.info(`${this.log_session_text} redirectToChateRoom`);
    liff.closeWindow();
  }

  redirectToNextPage() {
    this.logger.info(`${this.log_session_text} goto page application-form-readonly`);
    this.router.navigate(["../application-form-readonly"], { relativeTo: this.route, queryParams: this.queryParams });
  }

}
